export enum ContractType {
  vendor = 'vendor',
  client = 'client',
  employee = 'employee',
  lease = 'lease',
  service = 'service',
  software = 'software',
  other = 'other',
}

export enum ContractStatus {
  draft = 'draft',
  pending = 'pending',
  active = 'active',
  expired = 'expired',
  terminated = 'terminated',
  renewed = 'renewed',
}

export interface Contract {
  id: string;
  contractNumber: string;
  title: string;
  type: ContractType;
  status: ContractStatus;
  partyName: string; // Vendor, client, etc.
  partyType: 'vendor' | 'client' | 'employee' | 'other';
  partyId?: string; // Reference to vendor/client/employee
  startDate: Date;
  endDate?: Date;
  autoRenew: boolean;
  renewalDate?: Date;
  value: number;
  currency: string;
  paymentTerms?: string;
  terms?: string; // Contract terms text
  fileUrl?: string; // PDF or document
  keyDates: ContractKeyDate[];
  obligations: ContractObligation[];
  notes?: string;
  createdBy: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface ContractKeyDate {
  id: string;
  name: string;
  date: Date;
  description?: string;
  isCompleted: boolean;
}

export interface ContractObligation {
  id: string;
  description: string;
  responsibleParty: string;
  dueDate?: Date;
  isCompleted: boolean;
  completedAt?: Date;
}

